export default "__VITE_ASSET__CiE0ZBrY__"